module.exports = __webpack_public_path__ + "img/no.7de91001.png";